<template>
  <div id="historyct" class="contentmodaldiv" data-backdrop="false">
    <div class="modaldiv">
      <div class="contentmodal animate__animated animate__bounceInDown">
        <button class="closepopup" data-dismiss="modal">
          <i class="fas fa-times"></i>
        </button>
        <div class="login">
          <div class="logopopup">
            <img src="/static/img/logo/main_logo_20221004223046.png" />
          </div>
          <h1>ประวัติธุรกรรม (20 รายการล่าสุด)</h1>
          <div class="row mt-3">
            <div class="col-2 p-0 leftdps">
              <div
                id="v-pills-tab"
                role="tablist"
                aria-orientation="vertical"
                class="nav flex-column nav-pills"
              >
                <a
                  id="v-pills-dps-tab"
                  data-toggle="pill"
                  href="#v-pills-dps"
                  role="tab"
                  aria-controls="v-pills-dps"
                  aria-selected="true"
                  class="nav-link green active"
                  >ฝาก</a
                >
                <a
                  id="v-pills-wd-tab"
                  data-toggle="pill"
                  href="#v-pills-wd"
                  role="tab"
                  aria-controls="v-pills-wd"
                  aria-selected="false"
                  class="nav-link red"
                  >ถอน</a
                >
                <!-- <a
                  id="v-pills-hisreturn_balance-tab"
                  data-toggle="pill"
                  href="#v-pills-hisreturn_balance"
                  role="tab"
                  aria-controls="v-pills-hisreturn_balance"
                  aria-selected="false"
                  class="nav-link red"
                  >โบนัสคืนยอดเสีย</a
                >
                <a
                  id="v-pills-hisreturn_deposit-tab"
                  data-toggle="pill"
                  href="#v-pills-hisreturn_deposit"
                  role="tab"
                  aria-controls="v-pills-hisreturn_deposit"
                  aria-selected="false"
                  class="nav-link red"
                  >โบนัสคืนยอดฝาก</a
                > -->
              </div>
            </div>
            <div class="col-10 p-0 containhislist">
              <div id="v-pills-tabContent" class="tab-content">
                <div
                  id="v-pills-dps"
                  role="tabpanel"
                  aria-labelledby="v-pills-dps-tab"
                  class="tab-pane fade active show"
                >
                  <div class="containerhis history-scroll">
                    <div class="row">
                      <div class="col-12 mx-auto  text-center">
                        <span v-if="depositList.length == 0">ไม่มีข้อมูล</span>
                        <table
                          id="history-content-deposit"
                          class="table dataTable no-footer"
                          width="100%"
                          role="grid"
                          style="width: 100%;"
                          v-if="depositList.length > 0"
                        >
                          <thead>
                            <tr role="row">
                              <th>
                      จำนวน</th>
                    <th>
                      เวลา</th>
                    <th>
                      ประเภท</th>
                    <th>
                      สถานะ</th>
                  </tr>
                          </thead>

                          <tbody>
                            <tr
                              v-for="(data, i) in depositList"
                              v-bind:key="i"
                              role="row"
                            >
                            <td>
                      {{ data.Amount | formatNumber }} บาท</td>
                    <td>
                      {{
                        getDate(data.createdAt)
                      }}</td>

                    <td>
                      <span class="badge rounded-pill bg-success" v-if="data.BonusInfo._id == 'ITEMCODE'">
                        เครดิตฟรี
                      </span>
                      <span class="badge rounded-pill bg-success" v-else-if="data.BonusInfo._id == null">
                        ไม่รับโบนัส
                      </span>
                      <span class="badge rounded-pill bg-success"
                        v-else-if="data.BonusInfo._id != null && data.BonusInfo._id != 'ITEMCODE'">
                        รับโบนัส
                      </span>
                    </td>

                    <td>
                      <span class="badge rounded-pill bg-success" v-if="data.Status == 0">

                        อนุมัติ
                      </span>

                      <span class="badge rounded-pill bg-success" v-if="data.Status == 1">

                        อนุมัติ
                      </span>

                      <span class="badge rounded-pill .bg-light" v-if="data.Status == 2">

                        รอดำเนินการ
                      </span>

                      <span class="badge rounded-pill bg-danger" v-if="data.Status == 3">

                        ล้มเหลว
                      </span>

                    </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="v-pills-wd"
                  role="tabpanel"
                  aria-labelledby="v-pills-wd-tab"
                  class="tab-pane fade"
                >
                  <div class="containerhis history-scroll">
                    <div class="row">
                      <div class="col-12 mx-auto  text-center">
                        <span v-if="withdrawList.length == 0">ไม่มีข้อมูล</span>
                        <table
                          id="history-content-withdraw"
                          class="table dataTable no-footer"
                          width="100%"
                          role="grid"
                          style="width: 100%;"
                          v-if="withdrawList.length > 0"
                        >
                          <thead>
                            <tr role="row">
                              <th>
                                จำนวน
                              </th>
                              <th>
                                เวลา
                              </th>
                              <th>
                                สถานะ
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(data, i) in withdrawList"
                              v-bind:key="i"
                              role="row"
                            >
                              <td>{{ data.Amount | formatNumber }} บาท</td>
                              <td>
                                {{ getDate(data.createdAt) }}
                              </td>
                              <td>
                                <span
                                  class="badge rounded-pill bg-success"
                                  v-if="data.Status == 0"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  อนุมัติ
                                </span>

                                <span
                                  class="badge rounded-pill bg-success"
                                  v-if="data.Status == 1"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  อนุมัติ
                                </span>

                                <span
                                  class="badge rounded-pill .bg-light"
                                  v-if="data.Status == 2"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  รอดำเนินการ
                                </span>

                                <span
                                  class="badge rounded-pill bg-danger"
                                  v-if="data.Status == 3"
                                >
                                  <i class="fas fa-check-circle"></i>
                                  ล้มเหลว
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="v-pills-hisreturn_balance"
                  role="tabpanel"
                  aria-labelledby="v-pills-hisreturn_balance-tab"
                  class="tab-pane fade"
                >
                  <div class="containerhis history-scroll">
                    <div class="row">
                      <div class="col-12 mx-auto  text-center">
                        <span>ไม่มีข้อมูล</span>
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  id="v-pills-hisreturn_deposit"
                  role="tabpanel"
                  aria-labelledby="v-pills-hisreturn_deposit-tab"
                  class="tab-pane fade"
                >
                  <div class="containerhis history-scroll">
                    <div class="row">
                      <div class="col-12 mx-auto  text-center">
                        <span>ไม่มีข้อมูล</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="overlaymodal"></div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { UserInfoMixins } from "@/mixins/UserInfo.js";
import { fetchDeposit } from "@/services/modules/deposit.js";
import { Initialize } from "@/services/modules/withdraw.js";
import { fetchTran } from "@/services/modules/history.js";

import { PrefixMixins } from "@/mixins/Prefix.js";
import { BankMixins } from "@/mixins/BankService.js";

import moment from "moment";
export default {
  name: "HistoryForm",
  mixins: [UserInfoMixins, PrefixMixins, BankMixins],
  data() {
    return { depositList: [], withdrawList: [], Transfer: [], tab: 1 };
  },
  computed: {
    ...mapGetters([
      "getError",
      "getLoading",
      "getLineId",
      "getGameList",
      "getPromotion",
      "getPrefix",
    ]),
  },
  methods: {
    getDate: function(data) {
      return moment(data).format("DD MMMM YYYY, h:mm:ss a");
    },

    async fetchTransfer() {
      await fetchTran((res) => {
        console.log("fetchTransfer");
        console.log(res.data);

        if (res.status) {
          this.Transfer = res.data;
        } else {
        }
      });
    },

    async fetchDeposit() {
      await fetchDeposit((res) => {
        if (res.status) {
          console.log("fetchDeposit");
          console.log(res);
          this.depositList = res.data;
        } else {
        }
      });
    },
    async fetchWithdraw() {
      await Initialize((res) => {
        console.log("fetchWithdraw");
        console.log(res.data.Transaction);

        if (res.status) {
          this.withdrawList = res.data.Transaction;
        } else {
        }
      });
    },
  },
  async mounted() {
    await this.fetchTransfer();
    await this.fetchDeposit();
    await this.fetchWithdraw();
  },
};
</script>
<style scoped>
.leftdps .nav-link {
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/form/HistoryForm.vue